module.exports = __webpack_public_path__ + "img/ResultsTypes_AgriculturalRisk.06c52ba6.jpg";